import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";
export default class ReporteZ {
  monedaDefault = "";
  static totalSistema = 0;
  static totalSistemaOtros = 0;
  static subTotalProductos = 0;
  static taxProductos = 0;
  static totalPropinas = 0;
  static totalPropinasOtros = 0;
  constructor() { }

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.Productos);
    //let getFirmas = this.getFirmas(mainData.processedDataMesero,mainData.porcentaje)
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "portrait",
      content: [
        //header
        {
          columns: [
            {
              // star-sized columns fill the remaining space
              // if there's more than one star-column, available width is divided equally
              width: "25%",
              text: "",
            },
            {
              // fixed width
              width: "50%",
              alignment: "center",
              bold: true,
              text: [mainData.TITLE + "\n", mainData.CateName + "\n"],
            },
            {
              // % width
              width: "25%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora: " + mainData.HG + "\n",
              ],
            },
          ],
          // optional space between columns
          columnGap: 10,
        },
        {
          columns: [
            {
              // fixed width
              width: "100%",
              table: {
                widths: ["*", "*", "*", "*"],
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data) {
    let times = [
      [
        { text: "Tipo Insumo", border: [true, true, true, true], fontSize: 12 },
        {
          text: "Insumo",
          border: [true, true, true, true],
          fontSize: 12,
        },
        { text: "Cantidad", border: [true, true, true, true], fontSize: 12 },
        { text: "Costo Insumo", border: [true, true, true, true], fontSize: 12 },
      ],
    ];
    let groupedData = [];
    let orderedData = _.orderBy(data, ["Categoria"], ["asc"]);
    orderedData.forEach((receta, index) => {
      groupedData.push({
        header: true,
        text: receta.Nombre + " Costo:" + receta.Costo + " " + receta.MonedaCosto + " || Precio Sugerido: " + pgsHelper.roundNumber((receta.Costo * 3) + (((receta.Costo * 3) / 100) * 16)) + " || Precio: " + receta.Precio + " " + receta.Moneda + ((receta.Rm) ? " || Rendimiento: " + receta.Rm + " " + receta.UM : ""),
      });
      receta.Catalogo.forEach((insumo) => {
        groupedData.push(insumo);
      });
    });



    groupedData.forEach((venta) => {
      let rowToAdd = [];
      if (!venta.header & !venta.footer) {

        rowToAdd = [
          {
            text: venta.Tipo,
            border: [true, true, false, false],
            fontSize: 10,
          },
          {
            text: venta.Nombre,
            border: [true, true, false, false],
            fontSize: 10,
          },
          {
            text: venta.Cantidad + " " + venta.UM,
            border: [true, true, false, false],
            fontSize: 10,
          },
          {
            fillColor: (Number(venta.Costo) == 0) ? "#FF9F8B" : "",
            text: pgsHelper.roundNumber(parseFloat(venta.Costo) * Number(venta.Cantidad)) + " " + venta.MonedaCosto,
            border: [true, true, false, false],
            fontSize: 10,
          },
        ];
        /*if(Number(venta.Costo) == 0){
          times.push(rowToAdd);
        }*/
        times.push(rowToAdd);
      }
      if (venta.header) {
        rowToAdd = [
          {
            text: venta.text,
            border: [true, true, true, true],
            fontSize: 12,
            colSpan: 4,
            fillColor: "#CCE3F4",
          },
        ];
        times.push(rowToAdd);
      }

    });

    return times;
  }


}
